import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';

/**
|--------------------------------------------------
| httpLink
|--------------------------------------------------
*/
export const httpLink = createHttpLink({
  uri: process.env.GRAPHQL_URL || '/graphql/',
  // uri: 'http://c5718cc13c15.ngrok.io/graphql/',
  credentials: 'include',
});

/**
|--------------------------------------------------
| uploadLink
|--------------------------------------------------
*/
export const uploadLink = createUploadLink({
  uri: process.env.GRAPHQL_URL || '/graphql/',
  // uri: 'http://127.0.0.1:8000/graphql/',
  credentials: 'include',
});

/**
|--------------------------------------------------
| setTokenLink
|--------------------------------------------------
*/
export const setTokenLink = setContext((_, s) => {
  // const token = getTokenFromStorage(localStorageKeys.TOKEN);
  console.log(s, 'MYTOKEN');

  return {
    headers: {
      ...s.headers,
      // ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});
